import { render, staticRenderFns } from "./eightShelf.vue?vue&type=template&id=9812f9d8&"
import script from "./eightShelf.vue?vue&type=script&lang=js&"
export * from "./eightShelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports